import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_VIEW_LOP_RLOP);

const _pk_name = "id";

const state = {
    data: [],
    viewreport: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data)
    },

    setReport: (state, payload) => {
        if (payload) {
            state.viewreport = payload;
        }
        //console.log('fetched reports', state.viewreport)
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {
    async fetchAll({ commit }, payload) {
        //console.log("[state/payroll/lopsandrlops/fetchAll] Calling API...");
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`);
            commit("setFetching", false);
            //console.log("[state/payroll/lopsandrlops/fetchAll] res: ", res);
            if (res.status == 200) {
                commit("set", payload);
            }
            return res;
        } catch {

        }
    },

    async fetchReports({ commit }, payload) {
        //console.log("[state/payroll/viewreport/fetchreports] Calling API...");
        //console.log('payload paygroup id', payload)
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`, {
                params: {
                    paygroupId: payload
                }
            });
            commit("setFetching", false);
            //console.log("[state/payroll/lopsandrlops/fetchAll] res: ", res);
            if (res.status == 200) {
                commit("setReport", res.data.rows);
            }
            return res;
        } catch {

        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
